/**
 * Types and constants for `/claims/call-for-assistance` navigation state (branching copy and Back URL).
 * @module claims/claimCallAssistanceLocationState
 */

import type { PolicyLink } from '../services/types'

/** Sent in `location.state` when the user picks off-road as the other-claim subtype. */
export const CLAIM_CALL_ASSISTANCE_REASON_OFF_ROAD = 'off-road' as const

/**
 * Sent when the user answers “No” to safe/legal to drive on the other-claim subtype step; Back
 * returns to `/claims/other/subtype` with the same policy context.
 */
export const CLAIM_CALL_ASSISTANCE_REASON_VEHICLE_NOT_SAFE_OTHER_SUBTYPE =
  'vehicle-not-safe-other-subtype' as const

/**
 * Optional `location.state` for `/claims/call-for-assistance` to branch copy and back navigation.
 */
export type ClaimCallAssistanceLocationState = {
  assistanceReason?:
    | typeof CLAIM_CALL_ASSISTANCE_REASON_OFF_ROAD
    | typeof CLAIM_CALL_ASSISTANCE_REASON_VEHICLE_NOT_SAFE_OTHER_SUBTYPE
  policy?: PolicyLink
  policyRef?: string | null
  typeHint?: '4x4' | 'caravan' | 'camper' | null
}
